/* eslint-disable */
require('./credit_score')
require('./goals')
require('./gross_income')
require('./gross_income-ir')
require('./interests')
require('./job')
require('./relationship')
